export const CUSTOMER_CARD_ADDED = "CUSTOMER_CARD_ADDED";
export const CUSTOMER_CARD_ADDED_SUCCESS = "CUSTOMER_CARD_ADDED_SUCCESS";
export const CUSTOMER_CARD_ADDED_ERROR = "CUSTOMER_CARD_ADDED_ERROR";

// Get Customer Cards List
export const GET_CUSTOMER_CARDS = "GET_CUSTOMER_CARDS";
export const GET_CUSTOMER_CARDS_SUCCESS = "GET_CUSTOMER_CARDS_SUCCESS";
export const GET_CUSTOMER_CARDS_ERROR = "GET_CUSTOMER_CARDS_ERROR";
